import {
  Alert,
  AlertAction,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import useTranslations from "@/hooks/use-translations";
import { select_plan_path } from "@/lib/routes";
import { Link } from "@inertiajs/react";
import { CircleAlertIcon } from "lucide-react";

export default function PlanLimitAlert({ title }: { title: string }) {
  const { t } = useTranslations();

  return (
    <Alert className="border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-50">
      <CircleAlertIcon />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        <p
          dangerouslySetInnerHTML={{
            __html: t("shared.plan_limit_alert.description_html"),
          }}
        />
      </AlertDescription>
      <AlertAction>
        <Button size="xs" asChild>
          <Link href={select_plan_path({ params: { plan: "basic" } })}>
            {t("shared.plan_limit_alert.cta")}
          </Link>
        </Button>
      </AlertAction>
    </Alert>
  );
}
